import { Pipe, PipeTransform } from '@angular/core';
import { CaseService } from '../services/case.service';

@Pipe({
    name: 'FilterCaseDocumentListPipe',
    standalone: true
})
export class FilterCaseDocumentListPipe implements PipeTransform {
    constructor(private caseService: CaseService) {}

    transform(value: any[], downloadType: any, trigger: number = 0): any[] {
        let fileIds = this.caseService.getFileIdsByDownloadType(value, downloadType);
        let fullDocumentList = value;
        fullDocumentList = fullDocumentList.filter(file => {
            return fileIds.includes(file.FileId);
        });

        return fullDocumentList;
    }
}
